import Utils from '../../../utils/Utils';
import GuestActions from '../../../actions/GuestActions';

import NotificationActions from '../../../actions/NotificationActions';
import PopupActions from '../../../actions/PopupActions';

import UserStore from '../../../stores/UserStore';
import ConfigStore from '../../../stores/ConfigStore';

import { endPoints as EndPoints } from '../../../constants/GuestConstants';
import { endPoints as GuestListEndpoints } from '../../../constants/GuestListConstants';

import InputProfile from './InputProfile.react';
import DropdownProfile from './DropdownProfile.react';
import DOBProfile from './DOBProfile.react';
import DOB from '../../form/DOB.react';
import AdjustLoyaltyPoints from './AdjustLoyaltyPoints.react';
import EditExternalPatientAllotments from './EditExternalPatientAllotments.react';
import AdjustAllotment from './AdjustAllotment.react';
import ViewStorefrontAccess from './ViewStorefrontAccess.react';
import Addresses from './ProfileAddresses.react';
import DropdownProfileStates from './DropdownProfileStates'

import PageHeader from '../../form/layout/PageHeader.react';
import PageRow from '../../form/layout/PageRow.react';
import Input from '../../form/input/Input.react';
import InputDOB from '../../form/input/InputDOB.react';
import ReferenceDataStore from '../../../stores/ReferenceDataStore';

import AjaxPromises from '../../../utils/AjaxPromises';
import AllotmentInformation from './AllotmentInformation.react';
import PermissionStore from '../../../stores/PermissionStore';
import { Permissions } from '../../../constants/PermissionConstants';
import DaysSupplyInformation from './DaysSupplyInformation.react';


const CustomerProfilePOS = 'Customer Profile (POS)';

class ViewPersonal extends React.Component {

    constructor(props) {
        super(props);

        var guest = this.props.guest;

        var state_id_start = '';
        guest.identifications.forEach(id => {
            if (id.type === 'MJStateIDNo')
                state_id_start = moment(id.StartDate).format('MM/DD/YYYY');

            if (state_id_start === 'Invalid date')
                state_id_start = '';
        });

        var state_id_exp = '';
        for (var i = 0; i < guest.identifications.length; i++) {
            if (guest.identifications[i].type === 'MJStateIDNo') {
                state_id_exp = moment(guest.identifications[i].ExpirationDate).format('MM/DD/YYYY');
            }

            if (state_id_exp === 'Invalid date') {
                state_id_exp = '';
            }
        }

        var driver_license_id = '';
        var driver_license_id_exp = '';
        var additionalStateIdentifiers = '';
        for (var i = 0; i < guest.identifications.length; i++) {
            if (guest.identifications[i].type === 'DriversLicenseId') {
                driver_license_id = guest.identifications[i].number;
                driver_license_id_exp = moment(guest.identifications[i].ExpirationDate).format('YYYY-MM-DD');
                additionalStateIdentifiers = guest.identifications[i].additionalStateIdentifiers;
            }

            if (driver_license_id_exp === 'Invalid date') {
                driver_license_id_exp = '';
            }
        }

        this.state = {
            fullName        : guest.FullName,
            nickname        : guest.nickname,
            NamePrefix: guest.NamePrefix,
            FirstName : guest.FirstName,
            MiddleName : guest.MiddleName,
            LastName : guest.LastName,
            NameSuffix : guest.NameSuffix,
            gender          : guest.Gender.toLowerCase(),
            dob             : guest.DOB.length > 0 ? moment(guest.DOB).format('MM/DD/YYYY') : '',
            status          : guest.status,
            group_1         : (_.find(guest.discounts, x => x.Group === 'Group1') || { id: '' }).id,
            group_2         : (_.find(guest.discounts, x => x.Group === 'Group2') || { id: '' }).id,
            group_3         : (_.find(guest.discounts, x => x.Group === 'Group3') || { id: '' }).id,
            group_4         : (_.find(guest.discounts, x => x.Group === 'Group4') || { id: '' }).id,
            group_5         : (_.find(guest.discounts, x => x.Group === 'Group5') || { id: '' }).id,
            street          : guest.address.street,
            county          : guest.address.state.toUpperCase(),
            city            : guest.address.city,
            postal_code     : guest.address.postal_code,
            state_id        : guest.MJStateIDNo,
            mmjIdState: guest.MMJIDState,
            DDNumber: guest.DDNumber,
            state_id_start  : state_id_start,
            state_id_exp    : state_id_exp,
            driver_license_id : driver_license_id,
            driver_license_id_exp : driver_license_id_exp,
            additionalStateIdentifiers: additionalStateIdentifiers,
            email           : guest.Email,
            phone           : (guest.PhoneNo || '').replace(/[^0-9]/g, ''),
            cellPhone       : (guest.CellPhone || '').replace(/[^0-9]/g, ''),
            username        : guest.UserName,

            onlineEmailLogin : guest.Email,
            onlinePassword  : '',
            onlineStatus    : 'Inactive',
            externalName    : guest.ExternalName,
            CustomIdentifier: guest.CustomIdentifier,
            discount_groups : [],
            customerTypes: [],
            CustomerTypeId: guest.CustomerTypeId || '',
            preferredMethodOfContact: guest.PreferredMethodOfContact,
            OptedIntoEngagementSMS: guest.OptedIntoEngagementSMS,
            OptedIntoMarketing: guest.OptedIntoMarketing,
            cycleDate: moment(guest.CycleDate).isValid() ? moment(guest.CycleDate).format('MM/DD/YYYY') : '',
            allotmentData: guest.AllotmentData,
            ReferralSourceId: guest.ReferralSourceId,
            OtherReferralSource: guest.OtherReferralSource,
            referralSources: [],
            files: [],
            expirationDate: '',
            fileType: '',
            addressBook: guest.AddressBook,
            createAddress: false,
            newStreet: '',
            newCounty: '',
            newCity: '',
            newPostal: '',
            editingAddress: false,
            showEditExternalPatientAllotments: false,
        };

        this.fetchFiles = this.fetchFiles.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.downloadFile = this.downloadFile.bind(this);
        this.componentDidUpdate = this.componentDidUpdate.bind(this);
        this.onChange = this.onChange.bind(this);
        this.getFormData = this.getFormData.bind(this);
        this.checkBiotrack = this.checkBiotrack.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.validatePhone = this.validatePhone.bind(this);
        this.getErrors = this.getErrors.bind(this);
        this.setReferenceData = this.setReferenceData.bind(this);
        this.setAddresses = this.setAddresses.bind(this);
        this.toggleCreateAddress = this.toggleCreateAddress.bind(this);
        this.deleteAddress = this.deleteAddress.bind(this);
        this.convertToNonAnonUser = this.convertToNonAnonUser.bind(this);
        this.validateDOB = this.validateDOB.bind(this);
    }

    componentDidMount() {
        this.loadAvailableDiscountGroups();
        this.setReferenceData();
        this.fetchFiles();
    }

    async fetchFiles() {
        AjaxPromises.POST(EndPoints.GET_GUEST_FILE_LIST, UserStore.getApiData({
            PatientId: this.props.guest.Guest_id.toString(),
        })).then((resp) => {
            if (resp.Result) {
                this.setState({ files: resp.Data });
            } else if (!resp.Result) {
                NotificationActions.error(`Failed to get customer file list: ${res.Message}`);
            }
        });
    }

    uploadFile(data) {
        var self = this;

        if (data.target.files && data.target.files.length > 0) {
            let file = data.target.files[0];

            var reader = new FileReader();
            reader.onload = async function () {
                AjaxPromises.POST(EndPoints.UPLOAD_GUEST_FILE, UserStore.getApiData({
                    PatientId: this.props.guest.Guest_id.toString(),
                    FileName: file.name,
                    FileBytes: reader.result,
                    ExpirationDate: this.state.expirationDate,
                    FileType: this.state.fileType
                })).then(() => {
                    self.fetchFiles();
                });
            }.bind(this);

            reader.readAsDataURL(file);
        }
    }

    async downloadFile(fileName) {
        AjaxPromises.POST(EndPoints.DOWNLOAD_GUEST_FILE, UserStore.getApiData({
            PatientId: this.props.guest.Guest_id.toString(),
            FileName: fileName,
        })).then((resp) => {
            var binaryString = window.atob(resp.Data);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(new Blob([bytes], { type: 'application/text' }));
            link.download = fileName;
            link.target = '_blank';
            link.click();
        });
    }

    setReferenceData() {
        var guest = this.props.guest;
        var userData = UserStore.getState();
        var customerTypes = userData.customerTypes.reduce((acc, t) => {
            if (guest.IsAnonymous && (t.IsRetail && !t.IsMedical)) {
                acc.push({ title: t.CustomerType, option: t.CustomerTypeId });
            } else if (!guest.IsAnonymous) {
                acc.push({ title: t.CustomerType, option: t.CustomerTypeId });
            }
            return acc;
        }, [{ title: '-', option: ''}]);

        var referralSources = [{ title: '-', option: '' }];
        var sources = ReferenceDataStore.getState().referralSources;
        if (sources) {
            sources.forEach(s => {
                referralSources.push({ title: s.ReferralSource, option: s.ReferralSourceId });
            });
        }

        this.setState({ customerTypes, referralSources });
    }

    componentDidUpdate() {
        if (this.state.createAddress && !this.state.editingAddress) {
            if (!_.isEqual(this.state.addressBook, this.props.guest.AddressBook)) {
                this.setState({ addressBook: this.props.guest.AddressBook });
                this.toggleCreateAddress();
            }
        }
        this.props.checkForChanges();
    }

    getErrors() {

        if (!this.validateEmail(this.state.email)) {
            return 'Invalid email';
        }

        if (!this.validatePhone(this.state.phone)) {
            return 'Invalid phone number';
        }

        if (!this.validatePhone(this.state.cellPhone)) {
            return 'Invalid mobile phone';
        }

        if (!this.validateDOB(this.state.dob)) {
            return 'Invalid date of birth';
        }

        if(parseInt(this.state.CustomerTypeId) == 21 && !this.state.mmjIdState) {
            return 'Out of state medical customers must have a MMJID State';
        }

        var validationError = UserStore.getFormError(CustomerProfilePOS, this.state);

        if (validationError) {
            return validationError;
        }

        return false;
    }

    validateDOB(dob) {
        const isValidDOB = dob && dob.length === 10 && moment(dob).isValid() && !moment(dob).isAfter(moment());
        if (UserStore.isFieldRequired(CustomerProfilePOS, 'dob')) {
            return isValidDOB;
        }
        return dob.length === 0 || isValidDOB;
        
    }

    validateEmail(email) {
        if (!email) {
            return true;
        }

        const pattern = '^(([^<>()\\[\\]\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';
        var regex = new RegExp(pattern);
        return regex.test(email);
    }

    validatePhone(phone) {
        if (!phone) {
            return true;
        }

        var regexp = new RegExp('^[0-9]{10}$');
        return regexp.test(phone);
    }

    componentWillReceiveProps(next) {
        var state_id_exp = '';
        var state_id_start = '';
        next.guest.identifications.forEach(id => {
            if (id.type === 'MJStateIDNo') {
                state_id_start = moment(id.StartDate).format('MM/DD/YYYY');
                state_id_exp = moment(id.ExpirationDate).format('MM/DD/YYYY');
            }

            if (state_id_start === 'Invalid date') {
                state_id_start = '';
            }
            if (state_id_exp === 'Invalid date') {
                state_id_exp = '';
            }
        });

        this.setState({
            state_id: next.guest.MJStateIDNo,
            state_id_start: state_id_start,
            state_id_exp: state_id_exp,
            allotmentData: next.guest.AllotmentData,
            editingAddress: false
        });
    }

    loadAvailableDiscountGroups() {
        var self = this;
        var formData = UserStore.getApiData();

        AjaxPromises.POST(EndPoints.GET_DISCOUNT_GROUPS,
            formData).then(res => {
                self.setState({
                    discount_groups: res.Data ? res.Data : [],
                });
            }
        );
    }

    onChange(field, val) {
        this.setState({ [field]: val });
    }

    setAddresses(field, val, address = null) {
        if (address) {
            var a = address;

            if (field == 'county') {
                field = 'state';
            }
            let addressBook = this.state.addressBook.map(x => {
                if (x.AddressId === a.AddressId) {
                    return Object.assign({}, x, { [field]: val });
                }

                return x;
            });

            this.setState({ addressBook, editingAddress: true });
        } else {
            this.setState({ [field]: val });
        }
    }

    toggleCreateAddress() {
        this.setState({
            createAddress: !this.state.createAddress,
            newStreet: '',
            newCity: '',
            newCounty: '',
            newPostal: '',
            newAdditionalStateIdentifiers: '',
        });
    }

    deleteAddress(addressId) {
        var self = this;
        this.setState({ editingAddress: true });
        AjaxPromises.POST(EndPoints.DELETE_GUEST_ADDRESS, UserStore.getApiData({
            GuestId: this.props.guest.Guest_id,
            AddressId: addressId,
        })).then(() => {
            let addressBook = self.state.addressBook.filter(x => x.AddressId !== addressId);
            self.setState({ addressBook });
            self.setstate({ editingAddress: false });
            GuestActions.loadFullGuest(self.props.guest.Guest_id);
        });
    }

    getFormData(formData, saveChanges = false) {
        var newAddress = null

        if (saveChanges && this.state.createAddress) {
            newAddress = { AddressId: null, street: this.state.newStreet, city: this.state.newCity, state: this.state.newCounty, postal_code: this.state.newPostal };
        }

        formData.FullName   = this.state.fullName.trim();
        formData.NamePrefix = this.state.NamePrefix.trim();
        formData.FirstName = this.state.FirstName.trim();
        formData.MiddleName = this.state.MiddleName.trim();
        formData.LastName = this.state.LastName.trim();
        formData.NameSuffix = this.state.NameSuffix.trim();
        formData.nickname   = this.state.nickname.trim();
        formData.ExternalName   = this.state.externalName;
        formData.gender     = this.state.gender;
        formData.dob        = this.state.dob.length > 0 ? this.state.dob : null;
        formData.status     = this.state.status;
        formData.MJStateIDNo = this.state.state_id.trim();
        formData.MMJIDState = this.state.mmjIdState;
        formData.DDNumber = this.state.DDNumber;

        formData.MJStateIDStartDate = this.state.state_id_start.length > 0 ? this.state.state_id_start : null;
        formData.ExpirationDate = this.state.state_id_exp.length > 0 ? this.state.state_id_exp : null;

        formData.DriversLicenseId = this.state.driver_license_id.trim();
        formData.DLExpirationDate = this.state.driver_license_id_exp.length > 0 ? this.state.driver_license_id_exp : null;
        formData.additionalStateIdentifiers = this.state.additionalStateIdentifiers;
        formData.CustomIdentifier = this.state.CustomIdentifier;

        formData.street = this.state.street.trim();
        formData.city = this.state.city.trim();
        formData.state = this.state.county;
        formData.email = this.state.email.trim();
        formData.postal_code = this.state.postal_code.trim();
        formData.country_code = 'US';
        formData.PhoneNo = this.state.phone.trim();
        formData.CellPhone = this.state.cellPhone.trim();
        formData.PreferredMethodOfContact = this.state.preferredMethodOfContact;
        formData.OptedIntoMarketing = this.state.OptedIntoMarketing;
        formData.OptedIntoEngagementSMS = this.state.OptedIntoEngagementSMS;
        formData.CycleDate = this.state.cycleDate;
        formData.CustomerTypeId = this.state.CustomerTypeId;
        formData.ReferralSourceId = this.state.ReferralSourceId;
        formData.OtherReferralSource = this.state.OtherReferralSource;

        formData.Group1_Id = this.state.group_1;
        formData.Group2_Id = this.state.group_2;
        formData.Group3_Id = this.state.group_3;
        formData.Group4_Id = this.state.group_4;
        formData.Group5_Id = this.state.group_5;
        formData.AddressBook = [...this.state.addressBook];
        if (newAddress) {
            formData.AddressBook.push(newAddress);
        }

        return formData;
    }

    checkBiotrack() {
        var self = this;
        var formData = UserStore.getApiData();
        formData.PatientScan = this.props.guest.MJStateIDNo;
        formData.ScanSession = formData.sessionId;

        AjaxPromises.POST(GuestListEndpoints.BIOTRACK_VALIDATE_USER,
            formData).then(res => {

                if (res.Result === 'true') {
                    NotificationActions.addNotification({
                        type: 'success',
                        body: res.Message,
                        fullscreen: true,
                        sticky: true,
                    });
                } else {
                    NotificationActions.addNotification({
                        type: 'error',
                        body: res.Message,
                    });
                }
            }
        );
    }

    convertToNonAnonUser() {
        var self = this;
        AjaxPromises.POST(EndPoints.CONVERT_GUEST_NON_ANON, UserStore.getApiData({
            Guest_Id: this.props.guest.Guest_id
        })).then(() => {
            GuestActions.loadFullGuest(self.props.guest.Guest_id);
            this.setState({ confirmConversion: false });
        });
    }

    render() {
        var self = this;
        var page = this.props.page;
        var allotmentData = this.state.allotmentData || {};
        allotmentData.CycleDate = this.state.cycleDate;

        if (page !== 'personal') {
            return null;
        }

        const guest = this.props.guest;
        const lspId = UserStore.getState().user.LspId;
        const selectedLocation = UserStore.getState().selectedLocation;
        const useExternalName = selectedLocation.UseExternalName;
        const useCRM = selectedLocation.UseCRM
        const addressBook = this.state.addressBook;

        const discount_groups_arr = [{ title: '-', option: '' }].concat(this.state.discount_groups.map(x => {
            return { title: x.DiscountDescription, option: x.Id };
        }));

        return (
            <div className='container'>

                <div className='row'>
                    <div className='col-12'>
                        <div className='profile-main__container--header profile-main__container--first'>
                            {guest.FullName}
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-6'>
                        Created
                    </div>
                    <div className='col-6'>
                        {moment(guest.CreationDate || '').isValid() ? moment(guest.CreationDate).format('MM/DD/YYYY') : '-'}
                    </div>
                </div>

                <div className='row'>
                    <div className='col-6'>
                        Last Purchase
                    </div>
                    <div className='col-6'>
                        {moment(guest.LastPurchase).isValid() ? moment(guest.LastPurchase).format('MM/DD/YYYY') : '-'}
                    </div>
                </div>

                { (selectedLocation.ShowLeafLogixLoyalty && !guest.IsAnonymous) &&
                    <div className='row'>
                        <div className='col-6'>
                            Available Loyalty Points
                        </div>
                        <AdjustLoyaltyPoints
                            guest={guest} />
                    </div>
                }

                { this.state.showEditExternalPatientAllotments &&
                    <div className='row'>
                        <EditExternalPatientAllotments
                            guest={guest}
                            onClose={() => {this.setState({showEditExternalPatientAllotments: !this.state.showEditExternalPatientAllotments})}}/>
                    </div>
                }

                { selectedLocation.UseBioTrackPOS &&
                    <div className='row'>
                        <div
                            className='col-6'
                            onClick={this.checkBiotrack}
                            style={{ 'cursor': 'pointer' }}>

                            Check Biotrack
                        </div>
                        <div className='col-6'>

                        </div>
                    </div>
                }

                {guest.IsAnonymous && [
                    <div className='row'>
                        <div className='col-12'>
                            <div className='profile-main__container--header'>
                                Anonymous Customer
                            </div>
                        </div>
                    </div>,
                    <div className='row'>
                        <div className='col-6'>
                            <div 
                                className='btn-green'
                                onClick={() => this.setState({ confirmConversion: true })}>
                                CONVERT TO NON-ANONYMOUS 
                            </div>
                        </div>
                        <div className='col-6'>

                        </div>
                    </div>,
                ]}

                {selectedLocation.ShowDaysSupplyCalculator ?
                    <React.Fragment>             
                        <div className='row'>
                            <div className='col-12'>
                                <div className='profile-main__container--header'>
                                    Days Supply Info
                                </div>
                            </div>
                        </div>

                        <DaysSupplyInformation
                            guest={guest}
                            location={selectedLocation}
                        />
                    </React.Fragment>

                    :
                    
                    <React.Fragment>
                        <div className='row'>
                            <div className='col-12'>
                                <div className='profile-main__container--header'>
                                    Allotment Info
                                </div>
                            </div>
                        </div>

                        <AllotmentInformation
                            guest={guest}
                            data={allotmentData}
                            location={selectedLocation}
                        />
                        
                        {selectedLocation.UseMETRC && selectedLocation.EnableMETRCUpdatePatients &&
                            <div
                                className={'btn-green add-identification__btn ' + (!guest.IsAnonymous ? '' : 'btn-green__disabled')}
                                onClick={() => {this.setState({ showEditExternalPatientAllotments: !this.state.showEditExternalPatientAllotments });
                                }}>
                                Edit Allotments
                            </div>
                        }
                    </React.Fragment>
                }

                <div className='row'>
                    <div className='col-12'>
                        <div className='profile-main__container--header'>
                            Personal Details
                        </div>
                    </div>
                </div>
                {!UserStore.isFieldHidden(CustomerProfilePOS, 'NamePrefix') &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='NamePrefix'
                                disabled={guest.IsAnonymous}
                                value={this.state.NamePrefix}
                                onChange={this.onChange}
                                placeHolder='Title' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Prefix {UserStore.isFieldRequired(CustomerProfilePOS, 'NamePrefix') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }
                {!UserStore.isFieldHidden(CustomerProfilePOS, 'firstName') &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='FirstName'
                                disabled={guest.IsAnonymous}
                                value={this.state.FirstName}
                                onChange={this.onChange}
                                placeHolder='First Name' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                First Name {UserStore.isFieldRequired(CustomerProfilePOS, 'firstName') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }
                {!UserStore.isFieldHidden(CustomerProfilePOS, 'MiddleName') &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='MiddleName'
                                disabled={guest.IsAnonymous}
                                value={this.state.MiddleName}
                                onChange={this.onChange}
                                placeHolder='Middle Name' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Middle Name {UserStore.isFieldRequired(CustomerProfilePOS, 'MiddleName') ? '*' : ''}
                        </div>
                        </div>
                    </div>
                }
                {!UserStore.isFieldHidden(CustomerProfilePOS, 'LastName') &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='LastName'
                                disabled={guest.IsAnonymous}
                                value={this.state.LastName}
                                onChange={this.onChange}
                                placeHolder='Last Name' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Last Name {UserStore.isFieldRequired(CustomerProfilePOS, 'LastName') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }
                {!UserStore.isFieldHidden(CustomerProfilePOS, 'NameSuffix') &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='NameSuffix'
                                disabled={guest.IsAnonymous}
                                value={this.state.NameSuffix}
                                onChange={this.onChange}
                                placeHolder='Suffix' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Suffix {UserStore.isFieldRequired(CustomerProfilePOS, 'NameSuffix') ? '*' : ''}
                        </div>
                        </div>
                    </div>
                }
                {!UserStore.isFieldHidden(CustomerProfilePOS, 'externalName') &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='externalName'
                                disabled={guest.IsAnonymous}
                                value={this.state.externalName}
                                onChange={this.onChange}
                                placeHolder='External Name' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                External Name {UserStore.isFieldRequired(CustomerProfilePOS, 'externalName') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }
                {!UserStore.isFieldHidden(CustomerProfilePOS, 'nickname') &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='nickname'
                                disabled={guest.IsAnonymous}
                                value={this.state.nickname}
                                onChange={this.onChange}
                                placeHolder='Nickname' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Nickname {UserStore.isFieldRequired(CustomerProfilePOS, 'nickname') ? '*' : ''}
                        </div>
                        </div>
                    </div>
                }
                {!UserStore.isFieldHidden(CustomerProfilePOS, 'CustomIdentifier') &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='CustomIdentifier'
                                disabled={guest.IsAnonymous}
                                value={this.state.CustomIdentifier}
                                onChange={this.onChange}
                                placeHolder='Custom Identifier' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Custom Identifier {UserStore.isFieldRequired(CustomerProfilePOS, 'nickname') ? '*' : ''}
                        </div>
                        </div>
                    </div>
                }                
                {!UserStore.isFieldHidden(CustomerProfilePOS, 'gender') &&
                    <div className='row'>
                        <div className='col-6'>
                            <DropdownProfile
                                field='gender'
                                disabled={guest.IsAnonymous && !selectedLocation.CollectAnonymousDemo}
                                options={
                                    [
                                        { title: '-', option: '' },
                                        { title: 'Female', option: 'f' },
                                        { title: 'Male', option: 'm' },
                                        { title: 'Other', option: 'o' },
                                        { title: 'Not Specified', option: 'x' },
                                    ]}
                                selected={this.state.gender}
                                onChange={this.onChange} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Gender {UserStore.isFieldRequired(CustomerProfilePOS, 'gender') ? '*' : ''}
                        </div>
                        </div>
                    </div>
                }
                {!UserStore.isFieldHidden(CustomerProfilePOS, 'dob') &&
                    <div className='row'>
                        <div className='col-6'>
                            <DOB
                                field='dob'
                                disabled={guest.IsAnonymous && !selectedLocation.CollectAnonymousDemo}
                                value={this.state.dob}
                                onChange={this.onChange} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Date of birth {UserStore.isFieldRequired(CustomerProfilePOS, 'dob') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }
                {allotmentData.ShowCycleData &&
                    <div className='row'>
                        <div className='col-6'>
                            <DOB
                                AllowInFuture
                                field='cycleDate'
                                disabled={guest.IsAnonymous}
                                value={this.state.cycleDate}
                                onChange={this.onChange} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Cycle Date
                            </div>
                        </div>
                    </div>
                }
                {!UserStore.isFieldHidden(CustomerProfilePOS, 'CustomerTypeId') &&
                    <div className='row'>
                        <div className='col-6'>
                            <DropdownProfile
                                field='CustomerTypeId'
                                disabled={guest.IsAnonymous && !selectedLocation.CollectAnonymousDemo}
                                options={this.state.customerTypes}
                                selected={this.state.CustomerTypeId}
                                onChange={this.onChange} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Customer Type {UserStore.isFieldRequired(CustomerProfilePOS, 'CustomerTypeId') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }
                {!UserStore.isFieldHidden(CustomerProfilePOS, 'Status') &&
                    <div className='row'>
                        <div className='col-6'>
                            <DropdownProfile
                                required
                                field='status'
                                disabled={!PermissionStore.userCan(Permissions.EditPOSCustomerStatus) || guest.IsAnonymous}
                                options={
                                    [
                                        { title: '-', option: '' },
                                        { title: 'Active', option: 'Active' },
                                        { title: 'Banned', option: 'Banned' },
                                        { title: 'Cancelled', option: 'Cancelled' },
                                        { title: 'Hold', option: 'Hold' },
                                        { title: 'Inactive', option: 'Inactive' },
                                    ]}
                                selected={this.state.status}
                                onChange={this.onChange} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Status {UserStore.isFieldRequired(CustomerProfilePOS, 'Status') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }
                {!UserStore.isFieldHidden(CustomerProfilePOS, 'ReferralSourceId') &&
                    <div className='row'>
                        <div className='col-6'>
                            <DropdownProfile
                                field='ReferralSourceId'
                                disabled={guest.IsAnonymous}
                                options={this.state.referralSources}
                                selected={this.state.ReferralSourceId}
                                onChange={this.onChange}
                            />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Referred By {UserStore.isFieldRequired(CustomerProfilePOS, 'ReferralSourceId') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }
                {this.state.ReferralSourceId == 7 && !UserStore.isFieldHidden(CustomerProfilePOS, 'OtherReferralSource') &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='OtherReferralSource'
                                disabled={guest.IsAnonymous}
                                value={this.state.OtherReferralSource}
                                onChange={this.onChange}
                                placeHolder='Other Referral Source' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Other Referral Source {UserStore.isFieldRequired(CustomerProfilePOS, 'OtherReferralSource') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }

                {selectedLocation.HasEcommerce &&
                    <ViewStorefrontAccess
                        guest={guest} />
                }

                <div className='row'>
                    <div className='col-12'>
                        <div className='profile-main__container--header'>
                            Contact Details
                        </div>
                    </div>
                </div>

                {!UserStore.isFieldHidden(CustomerProfilePOS, 'phone') &&
                    <div className='row'>
                        <div className='col-6'>
                            <div
                                className={'input-profile' + (!this.validatePhone(this.state.phone) ? '__error ' : ' ') + this.props.className}>

                                <input
                                    type='text'
                                    disabled={guest.IsAnonymous}
                                    value={Utils.formatPhoneNumber(this.state.phone)}
                                    onChange={(e) => { this.setState({ phone: e.target.value.replace(/[^0-9]/g, '') }); }}
                                    placeholder='Phone number' />
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Phone Number {UserStore.isFieldRequired(CustomerProfilePOS, 'phone') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }
                {!UserStore.isFieldHidden(CustomerProfilePOS, 'cellPhone') &&
                    <div className='row'>
                        <div className='col-6'>

                            <div
                                className={'input-profile' + (!this.validatePhone(this.state.cellPhone) ? '__error ' : ' ') + this.props.className}>
                                <input
                                    type='text'
                                    disabled={guest.IsAnonymous}
                                    value={Utils.formatPhoneNumber(this.state.cellPhone)}
                                    onChange={(e) => { this.setState({ cellPhone: e.target.value.replace(/[^0-9]/g, '') }); }}
                                    placeholder='Mobile Phone number' />
                            </div>
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Mobile Phone Number {UserStore.isFieldRequired(CustomerProfilePOS, 'cellPhone') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }
                {!UserStore.isFieldHidden(CustomerProfilePOS, 'email') &&
                    <div className='row'>
                        <div className='col-6'>
                            <InputProfile
                                field='email'
                                disabled={guest.IsAnonymous}
                                value={this.state.email}
                                onChange={this.onChange}
                                validate={this.validateEmail}
                                placeHolder='Email address' />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Email Address {UserStore.isFieldRequired(CustomerProfilePOS, 'email') ? '*' : ''}
                            </div>
                        </div>
                    </div>
                }
                {!UserStore.isFieldHidden(CustomerProfilePOS, 'preferredMethodOfContact') &&
                    <div className='row'>
                        <div className='col-6'>
                            <DropdownProfile
                                field='preferredMethodOfContact'
                                disabled={guest.IsAnonymous}
                                options={[
                                    { title: 'None', option: '' },
                                    { title: 'Phone', option: 'PhoneNo' },
                                    { title: 'Mobile Phone', option: 'CellPhone' },
                                    { title: 'E-Mail', option: 'Email' },
                                ]}
                                selected={this.state.preferredMethodOfContact}
                                onChange={this.onChange} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Preferred Method of Contact {UserStore.isFieldRequired(CustomerProfilePOS, 'preferredMethodOfContact') ? '*' : ''}
                        </div>
                        </div>
                    </div>
                }
                { useCRM &&
                    <div className='row'>
                        <div className='col-6'>
                            <DropdownProfile
                                field='OptedIntoEngagementSMS'
                                disabled={guest.IsAnonymous}
                                options={[
                                    { title: '-', option: '' },
                                    { title: 'Yes', option: 'true' },
                                    { title: 'No', option: 'false' },
                                ]}
                                selected={this.state.OptedIntoEngagementSMS}
                                onChange={this.onChange} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Opt Into Informational SMS
                            </div>
                        </div>
                    </div>
                }
                {useCRM &&
                    <div className='row'>
                        <div className='col-6'>
                            <DropdownProfile
                                field='OptedIntoMarketing'
                                disabled={guest.IsAnonymous}
                                options={[
                                    { title: '-', option: '' },
                                    { title: 'Yes', option: 'true' },
                                    { title: 'No', option: 'false' },
                                ]}
                                selected={this.state.OptedIntoMarketing}
                                onChange={this.onChange} />
                        </div>
                        <div className='col-6'>
                            <div className='profile-main__label'>
                                Opt Into SMS Marketing
                            </div>
                        </div>
                    </div>
                }

                {
                    //These are all of the "medical" customer types.  Checkout CustomerTypes in the database for specifics.
                    [1, 10, 14, 17, 20, 21].indexOf(parseInt(this.state.CustomerTypeId)) > -1 && [
                        <div className='row'>
                            <div className='col-12'>
                                <div className='profile-main__container--header'>
                                    Medical Identification
                                </div>
                            </div>
                        </div>,
                        !UserStore.isFieldHidden(CustomerProfilePOS, 'state_id') &&
                            <div className='row'>
                                <div className='col-6'>
                                    <InputProfile
                                        field='state_id'
                                        value={this.state.state_id}
                                        onChange={this.onChange}
                                        placeHolder='State Id Number' />
                                </div>
                                <div className='col-6'>
                                    <div className='profile-main__label'>
                                        MMJ ID {UserStore.isFieldRequired(CustomerProfilePOS, 'state_id') ? '*' : ''}
                                    </div>
                                </div>
                            </div>,

                        (parseInt(this.state.CustomerTypeId) == 21 || !UserStore.isFieldHidden(CustomerProfilePOS, 'mmjIdState')) &&
                            <div className='row'>
                                <div className='col-6'>
                                <DropdownProfileStates
                                    field='mmjIdState'
                                    disabled={this.props.isAnonymous}
                                    selected={this.state.mmjIdState}
                                    onChange={this.onChange}
                                    required={(parseInt(this.state.CustomerTypeId) == 21 || UserStore.isFieldRequired(CustomerProfilePOS, 'mmjIdState'))}
                                />
                                </div>
                                <div className='col-6'>
                                    <div className='profile-main__label'>
                                        MMJ ID State {UserStore.isFieldRequired(CustomerProfilePOS, 'mmjIdState') ? '*' : ''}
                                    </div>
                                </div>
                            </div>,

                        !UserStore.isFieldHidden(CustomerProfilePOS, 'state_id_start') &&
                            <div className='row'>
                                <div className='col-6'>
                                    <DOB
                                        field='state_id_start'
                                        AllowInFuture
                                        value={this.state.state_id_start}
                                        onChange={this.onChange} />
                                </div>
                                <div className='col-6'>
                                    <div className='profile-main__label'>
                                        MMJ ID Start Date {UserStore.isFieldRequired(CustomerProfilePOS, 'state_id_start') ? '*' : ''}
                                    </div>
                                </div>
                            </div>,

                        !UserStore.isFieldHidden(CustomerProfilePOS, 'state_id_exp') &&
                            <div className='row'>
                                <div className='col-6'>
                                    <DOB
                                        field='state_id_exp'
                                        AllowInFuture
                                        value={this.state.state_id_exp}
                                        onChange={this.onChange} />
                                </div>
                                <div className='col-6'>
                                    <div className='profile-main__label'>
                                        MMJ ID Expiration Date {UserStore.isFieldRequired(CustomerProfilePOS, 'state_id_exp') ? '*' : ''}
                                    </div>
                                </div>
                            </div>,

                        !UserStore.isFieldHidden(CustomerProfilePOS, 'DDNumber') &&
                            <div className='row'>
                                <div className='col-6'>
                                    <InputProfile
                                        field='DDNumber'
                                        value={this.state.DDNumber}
                                        onChange={this.onChange} 
                                        placeHolder="DD Number"    
                                    />
                                </div>
                                <div className='col-6'>
                                    <div className='profile-main__label'>
                                        Doctor Designation Number {UserStore.isFieldRequired(CustomerProfilePOS, 'DDNumber') ? '*' : ''}
                                    </div>
                                </div>
                            </div>,
                    ]}

                <PageHeader title='Driver License' />

                {!UserStore.isFieldHidden(CustomerProfilePOS, 'driver_license_id') &&
                    <PageRow title={UserStore.isFieldRequired(CustomerProfilePOS, 'driver_license_id') ? 'License Number*' : 'License Number'}>
                        <Input
                            autoComplete='new-password'
                            disabled={guest.IsAnonymous}
                            value={this.state.driver_license_id}
                            onChange={driver_license_id => { this.setState({ driver_license_id }); }}
                            className='fs-exclude'
                            type={selectedLocation.MaskDriversLicenseID ? 'password' : 'text'}
                        />
                    </PageRow>
                }

                {!UserStore.isFieldHidden(CustomerProfilePOS, 'driver_license_id_exp') &&
                    <PageRow title={UserStore.isFieldRequired(CustomerProfilePOS, 'driver_license_id_exp') ? 'License Expiration Date*' : 'License Expiration Date'}>
                        <InputDOB
                            disabled={guest.IsAnonymous}
                            value={this.state.driver_license_id_exp}
                            onChange={driver_license_id_exp => { this.setState({ driver_license_id_exp }); }} />
                    </PageRow>
                }

                {!UserStore.isFieldHidden(CustomerProfilePOS, 'additionalStateIdentifiers') &&
                    <PageRow title={UserStore.isFieldRequired(CustomerProfilePOS, 'additionalStateIdentifiers') ? 'Additional State Identifiers*' : 'Additional State Identifiers'}>
                        <Input
                            disabled={guest.IsAnonymous}
                            value={this.state.additionalStateIdentifiers}
                            onChange={additionalStateIdentifiers => { this.setState({ additionalStateIdentifiers }); }}
                            className='fs-exclude'
                            type={'text'}
                        />
                    </PageRow>
                }

                <div className='row'>
                    <div className='col-12'>
                        <div className='profile-main__container--header'>
                            Discount Groups
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='col-4'>
                        <DropdownProfile
                            field='group_1'
                            disabled={!PermissionStore.userCan(Permissions.EditDiscountGroupCustomers) || guest.IsAnonymous}
                            options={discount_groups_arr}
                            selected={this.state.group_1}
                            onChange={this.onChange} />
                    </div>
                    <div className='col-4'>
                        <DropdownProfile
                            field='group_2'
                            disabled={!PermissionStore.userCan(Permissions.EditDiscountGroupCustomers) || guest.IsAnonymous}
                            options={discount_groups_arr}
                            selected={this.state.group_2}
                            onChange={this.onChange} />
                    </div>
                    <div className='col-4'>
                        <DropdownProfile
                            field='group_3'
                            disabled={!PermissionStore.userCan(Permissions.EditDiscountGroupCustomers) || guest.IsAnonymous}
                            options={discount_groups_arr}
                            selected={this.state.group_3}
                            onChange={this.onChange} />
                    </div>
                </div>


                <div className='row'>
                    <div className='col-4'>
                        <DropdownProfile
                            field='group_4'
                            disabled={!PermissionStore.userCan(Permissions.EditDiscountGroupCustomers) || guest.IsAnonymous}
                            options={discount_groups_arr}
                            selected={this.state.group_4}
                            onChange={this.onChange} />
                    </div>
                    <div className='col-4'>
                        <DropdownProfile
                            field='group_5'
                            disabled={!PermissionStore.userCan(Permissions.EditDiscountGroupCustomers) || guest.IsAnonymous}
                            options={discount_groups_arr}
                            selected={this.state.group_5}
                            onChange={this.onChange} />
                    </div>
                </div>

                <div className='row'>
                    <div className='col-12'>
                        <div className='profile-main__container--header'>
                            Addresses
                            {!guest.IsAnonymous &&
                            <i
                                className={'fa ml-2 new-address ' + (!this.state.createAddress ? 'fa-plus' : 'fa-minus')}
                                aria-hidden='true'
                                title='Add new address'
                                onClick={this.toggleCreateAddress} />}
                        </div>
                    </div>
                </div>

                {this.state.createAddress &&
                    <div>
                        <p style={{ fontSize: '20px' }}>Add new address</p>
                        <Addresses
                            street={this.state.newStreet}
                            onChange={this.setAddresses}
                            city={this.state.newCity}
                            postal={this.state.newPostal}
                            county={this.state.newCounty}
                            newAddress={true}
                        />
                        <hr />
                    </div>
                }
               
                <Addresses
                    street={this.state.street}
                    onChange={this.setAddresses}
                    city={this.state.city}
                    postal={this.state.postal_code}
                    county={this.state.county}
                    isAnonymous={guest.IsAnonymous}
                />
                <hr/>
                
                {addressBook.map(address =>
                    <React.Fragment>
                        <Addresses
                            street={address.street}
                            onChange={this.setAddresses}
                            city={address.city}
                            postal={address.postal_code}
                            county={address.state}
                            address={address}
                        />
                        <i
                            className={'fa fa-trash-alt ml-2 delete-address'}
                            aria-hidden='true'
                            title='Delete Address'
                            onClick={() => this.deleteAddress(address.AddressId)} />
                        <hr />
                    </React.Fragment>
                )}

                <div className='row'>
                    <div className='col-12'>
                        <div className='profile-main__container--header'>
                            Patient Files
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='input col-3'>
                        <input className='form-control'
                            type='date'
                            disabled={guest.IsAnonymous}
                            id='file-expiration-date'
                            onChange={date => this.setState({ expirationDate: date.target.value })} />
                    </div>
                    <div className='input col-5'>
                        <input className='form-control'
                            type='text'
                            disabled={guest.IsAnonymous}
                            placeholder='File Type'
                            id='file-type'
                            onChange={type => this.setState({ fileType: type.target.value })} />
                    </div>
                    <div className='col-3'>
                    Upload Patient File
                    </div>
                </div>
                <div className='row'>
                    <div className='input col-4' style={{ padding: '12px 15px' }}>
                        <input
                            type='file'
                            id='patient-file'
                            disabled={guest.IsAnonymous}
                            onChange={this.uploadFile} />
                    </div>
                    </div>

                {Object.keys(this.state.files).length > 0 &&
                    <div className="row">
                        <div className="col-12">
                            <div className='row'>
                                <div className='col-1'>
                                    File Id
                                </div>
                                <div className='col-4'>
                                    Uploaded File Link
                                </div>
                                <div className='col-2'>
                                    Document Type
                                </div>
                                <div className='col-1'>
                                    Expiration Date
                                </div>
                                <div className='col-1'>
                                    Uploaded Date
                                </div>
                                <div className='col-2'>
                                    Uploaded By
                                </div>
                                <div className='col-1'>
                                </div>
                            </div>
                            {Object.keys(this.state.files).map((fileName, i) =>
                                <div className='row' style={{ background: (i % 2 == 0 ? '#EEE' : '#FFF') }}>
                                    <div className='col-1'>
                                    {i+1}
                                </div>
                                <div className='col-4'>
                                    <button className='btn btn-link text-left p-0' style={{whiteSpace: 'normal'}} onClick={() => { this.downloadFile(fileName) }}>
                                        {fileName}
                                    </button>
                                </div>
                                <div className='col-2'>
                                    {this.state.files[fileName]['FileType']}
                                </div>
                                <div className='col-1'>
                                    {this.state.files[fileName]['ExpirationDate']}
                                </div>
                                <div className='col-1'>
                                    {this.state.files[fileName]['UploadedDate']}
                                </div>
                                <div className='col-2'>
                                    {this.state.files[fileName]['UploadedBy']}
                                </div>
                                </div>
                            )}
                        </div>
                    </div>
                }
                {this.state.confirmConversion &&
                <div className='popup'>
                    <div className='popup__content remove-from-list__clear'>
                        <div className='popup-header'>
                            ARE YOU SURE?
                            <div
                                className='popup-close'
                                onClick={() => { this.setState({ confirmConversion: false }); }}>
    
                                <i className='fa fa-times' aria-hidden='true' />
                            </div>
                        </div>
    
                        <button
                            onClick={() => { this.setState({ confirmConversion: false }); }}>
    
                            CANCEL
                        </button>
    
                        <button
                            onClick={this.convertToNonAnonUser}>
    
                            CONFIRM
                        </button>
                    </div>
                </div>}
            </div>
        );
    }
}

export default ViewPersonal;



// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/ViewPersonal.react.jsx